import styled from "styled-components";

import { CheckedIcon, AddIcon } from "../../Svg";

export const CheckedWrapper = styled.div`
  position: absolute;
  right: 12px;
  bottom: 12px;
  height: 24px;
  width: 24px;
  border-radius: 100%;
  border: 1.5px solid #e9e9ff;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
`;

export const RemoveWrapper = styled.div`
  position: absolute;
  left: 12px;
  top: 12px;
  height: 24px;
  width: 24px;
  border-radius: 100%;
  border: 1.5px solid #fc7979;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
`;

export const BuyWrapper = styled.div`
  position: absolute;
  right: 12px;
  top: 12px;
  height: 24px;
  width: 24px;
  border-radius: 100%;
  border: 1.5px solid #e9e9ff;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
`;

export const ShutterstockMark = styled.div`
  position: absolute;
  left: 8px;
  top: 8px;
  height: 15px;
  width: 15px;
  opacity: 0.8;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
`;

export const ArchiveButton = styled.div`
  position: absolute;
  right: 8px;
  top: 8px;
  height: 30px;
  width: 30px;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  z-index: 50;
  filter: drop-shadow(3px 3px 6px rgba(0, 0, 0, 0.5)) drop-shadow(0px 0px 6px rgba(0, 0, 0, 0.5));
`;

export const CreativeWrapper = styled.figure`
  display: inline-block;
  position: relative;
  margin: 0 0 10px 0;
  grid-template-rows: 1fr auto;
  break-inside: avoid;
  cursor: pointer;
  transition: all 0.2s;
  width: 100%;
  height: 100%;
  border-radius: 4px;
  overflow: hidden;
  &:hover {
    transform: scale(1.02);
  }
  ${(props) =>
    props.active
      ? `
    ${CheckedWrapper} {
      opacity: 1;
    }
    ${RemoveWrapper} {
      opacity: 1;
    }
    ${BuyWrapper} {
      opacity: 1;
    }
  `
      : `
    ${CheckedWrapper} {
      opacity: 0;
    };
    ${BuyWrapper} {
      opacity: 0;
    };
    ${RemoveWrapper} {
      opacity: 0;
    };
    &:hover {
      ${CheckedWrapper} {
        opacity: 0.3;
      };
      ${RemoveWrapper} {
        opacity: 0.3;
      };
    };
  `}
`;

export const CreativeImg = styled.img`
  display: flex;
  grid-row: 1 / -1;
  grid-column: 1;
  width: 100%;
`;

export const CreativeVideoWrapper = styled.div`
  display: flex;
  grid-row: 1 / -1;
  grid-column: 1;
  width: 100%;
`;

export const Checked = styled(CheckedIcon)`
  display: flex;
  width: 20px;
  height: 20px;
`;
export const Add = styled(AddIcon)`
  display: flex;
`;
export const PlayIconWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -25px 0 0 -25px;
  width: 50px;
  height: 50px;
  transition: all 0.2s;
  ${(props) =>
    props.show
      ? `
    opacity: 0.8;
  `
      : `
    opacity: 0;
  `};
`;
